import { trigger, state, style, transition, animate, keyframes } from '@angular/animations';

export const StepAnimations = [
	trigger('stepState', [
		state('inactive', style({ opacity: 0, display: 'none' })),
		state('active', style({ opacity: 1, display: 'block' })),
		transition('inactive => active', [ style({ display: 'block' }), animate('200ms ease-in') ]),
	]),
	trigger('inFormPopup', [
		transition(':enter', [
			style({
				position: 'absolute',
				top: 0,
				left: 0,
				height: '100%',
				width: '565px',
				maxWidth: '100%',
				background:' #ffffff',
				zIndex: 60,
				transform: 'translateX(-100%)'
			}),
        	animate('400ms ease-in', style({transform: 'translateX(0%)'}))
		])
	])
];
